<template>
  <div
    class="lootbox-boxes-row"
    :class="type"
  >
    <a
      href="#"
      class="lootbox-boxes-row-scroll-btn"
      @click.prevent="$emit('openScroll')"
    >
      <IList width="24" />
      {{ scrollButton }}
    </a>
    <div class="lootbox-boxes-row-name">
      {{ name }}
    </div>

    <div class="lootbox-boxes-row-items">
      <div
        v-for="(item, idx) in items"
        :key="idx"
        class="lootbox-boxes-item"
        @click.prevent="$emit('buy', item)"
      >
        <div class="lootbox-boxes-item__image">
          <img
            width="210"
            :src="item.image"
            :alt="item.price"
          >
        </div>
        <div
          href="#"
          class="lootbox-boxes-item__count"
        >
          {{ item.amount }} Loot Box{{ item.amount > 1 ? 'es' : '' }}
        </div>
        <div class="lootbox-boxes-item__price">
          {{ item.price }}
        </div>
        <div
          v-if="buyingItem && buyingItem.amount === item.amount"
          class="lootbox-boxes-item__loading"
        >
          <img
            src="@/assets/img/spinner-clear.svg"
            class="loader"
            width="50"
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue"
import IList from "@/assets/icons/ape-constructor/ape-constructor-lootbox-scroll.svg?inline"
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import 'swiper/swiper-bundle.css';

export default defineComponent({
  components: {
    IList, Swiper,
    SwiperSlide
  },
  props: {
    scrollButton: String,
    name: String,
    buyingItem: {
      type: Object,
      default: () => ({})
    },
    type: String,
    items: {
      type: Array,
      default: () => { }
    }
  },
  setup() {
    const breakpoints = {
      800: {
        slidesPerView: 3,
        spaceBetween: 24

      },
      576: {
        spaceBetween: 24
      }
    }


    return { breakpoints, }
  }
})
</script>
<style lang="scss">
.lootbox-boxes {
  &-row {
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    &.legendary & {
      &-name {
        background-color: var(--rarity-legendary);
      }
    }
    &.epic & {
      &-name {
        background-color: var(--rarity-epic);
      }
    }
    &-items {
      display: flex;
    }
    &-name {
      text-transform: uppercase;
      padding: 8px;
      width: 100%;
      text-align: center;
      margin-bottom: 1px;
      box-sizing: border-box;
    }
    &-scroll-btn {
      display: inline-flex;
      align-items: center;
      font-weight: bold;
      color: #fff;
      font-size: 18px;
      text-transform: uppercase;
      margin-bottom: 14px;
      svg {
        margin-right: 8px;
      }
    }
  }

  &-item {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;

    background-color: #1f1f1f;
    border: 1px solid var(--ape-constructor-gray);
    padding-bottom: 12px;
    box-sizing: border-box;
    color: #fff;
    text-decoration: none;
    flex: 1;
    transition: filter 0.2s;
    &:hover {
      filter: brightness(0.8);
    }

    &__loading {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__image {
      margin-bottom: 8px;
      width: 100%;
      img {
        width: 100%;
        max-width: 100%;
      }
    }
    &__price {
      opacity: 0.8;
      font-weight: normal;
    }
    &__count {
      font-style: italic;
      font-size: 24px;
      text-transform: uppercase;
      margin-bottom: 8px;
    }
  }
  @media screen and (max-width: 768px) {
    &-item {
      &__count {
        font-size: 18px;
      }
    }
  }
  @media screen and (max-width: 576px) {
    &-item {
      padding-bottom: 8px;
      &__image {
        margin-bottom: 8px;
      }
      &__count {
        font-size: 16px;
        margin-bottom: 3px;
      }
      &__price {
        font-size: 14px;
      }
      &__loading {
        img {
          max-width: 60%;
        }
      }
    }
    &-row-scroll-btn {
      svg {
        width: 16px;
      }
      font-size: 14px;
    }
  }
  @media screen and (max-width: 420px) {
    &-item {
      &__count {
        font-size: 12px;
      }
      &__price {
        font-size: 12px;
      }
    }
  }
}
</style>